import { LabellingFlow } from '@ohif/ui-next';

export default {
  'ui.labellingComponent': LabellingFlow,
};
